import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_COMBOS = {
  'list': [],
  'loading': false,
};

export const combos = (state, action) => {
  return createReducer(INITIAL_STATE_COMBOS, {
    [ActionTypes.FETCHING_COMBOS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_COMBOS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_COMBOS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAN_COMBOS_LIST]: (state, action) => ({
      ...state,
      'list': [],
    }),
    [ActionTypes.UPLOADING_COMBO_HEADER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPLOADED_COMBO_HEADER]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPLOADED_COMBO_HEADER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};

const INITIAL_STATE_COMBO_ACCESSORIES = {
  'list': [],
  'loading': false,
};

export const comboAccessories = (state, action) => {
  return createReducer(INITIAL_STATE_COMBO_ACCESSORIES, {
    [ActionTypes.FETCHING_COMBO_ACCESSORIES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_COMBO_ACCESSORIES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_COMBO_ACCESSORIES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAN_COMBO_ACCESSORIES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

const INITIAL_STATE_COMBO_DEALERS = {
  'list': [],
  'loading': false,
};

export const comboDealers = (state, action) => {
  return createReducer(INITIAL_STATE_COMBO_DEALERS, {
    [ActionTypes.FETCHING_COMBO_DEALERS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_COMBO_DEALERS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_COMBO_DEALERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAN_COMBO_DEALERS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
